export function sanitizeFileName(fileName: string): string {
    return fileName
        .normalize('NFC')
        .replace(/[^\p{L}\p{M}\p{N} ._()-]/gu, '_')
        .trim();
}
